import Vue from 'vue'
import Vuex from 'vuex'

//import vuex modules here
import forums from './modules/forums'
import comments from './modules/comments'
import users from './modules/users'
import cms from './modules/cms'
import contact_us from './modules/contact_us'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    selectedLink: 'Home',
    links: [
      {
        name: 'Home',
        link: 'Home',
        authRequired: false
      },
      {
        name: 'About Us',
        link: 'About',
        authRequired: false
      },
      {
        name: 'Contact Us',
        link: 'Contact',
        authRequired: false
      },
      {
        name: 'Mental Health Support',
        link: 'Support',
        authRequired: false
      },
      {
        name: 'Forum',
        link: 'Forum',
        authRequired: false
      },
      {
        name: 'Profile',
        link: 'Profile',
        authRequired: true
      },
      {
        name: 'Admin',
        link: 'Admin',
        authRequired: true
      }
    ],
    toggleAuth: false
  },
  getters: {
    LINKS: (state) => state.links,
    SELECTED_LINK: (state) => state.selectedLink,
    TOGGLE_AUTH: (state) => state.toggleAuth
  },
  mutations: {
    SET_SELECTED_LINK(state, payload) {
      state.selectedLink = payload
    },
    SET_TOGGLE_AUTH(state, payload) {
      state.toggleAuth = payload
    }
  },
  actions: {},
  modules: {
    forums,
    comments,
    users,
    cms,
    contact_us
  }
})
